<template>
  <component :is="autoInjector"></component>
</template>
<script>
import LeaseMethodOne from "./LeaseMethodOne";
import LeaseMethodTwo from "./LeaseMethodTwo";
import FinanceMethodOne from "./FinanceMethodOne";
import FinanceMethodTwo from "./FinanceMethodTwo";
// Finance Method 2 == Flooring
export default {
  components: {
    FinanceMethodTwo,
    FinanceMethodOne,
    LeaseMethodOne,
    LeaseMethodTwo,
  },
  computed: {
    type: {
      get() {
        return this.$store.state.calculator.type;
      },
      set(val) {
        this.$store.commit("calculator/SET_TYPE", val);
      },
    },
    method: {
      get() {
        return this.$store.state.calculator.method;
      },
      set(val) {
        this.$store.commit("calculator/SET_METHOD", val);
      },
    },
    types() {
      return this.$store.state.calculator.types;
    },
    methods() {
      return this.$store.state.calculator.methods;
    },
    autoInjector() {
      if (this.type == "Lease") {
        if (this.method === "Method1") return "lease-method-one";
        else return "lease-method-two";
      } else if (this.type === "Finance") return "finance-method-one";
      else if (this.type === "Flooring") return "finance-method-two";
    },
  },
};
</script>

<style lang="scss">
.abc-d {
  color: #000 !important;
}
.form-element-calculator {
  margin: 10px 0px;
}
.calculate-label {
  font-size: 15px;
  color: #027be3;
  font-weight: bold;
}
</style>